module.exports = __webpack_public_path__ + "img/KSC09216.4fd72ada.jpg";